import { UsersList } from "@/components/admin/UsersList";
import { Header } from "@/components/SiteUI";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Toaster } from "@/components/ui/toaster";
import { isAuth } from "@/shared/api";
import { set } from "date-fns";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Page404 } from "../Page404";
import auth from "@/shared/api/auth";
import { ArticleList } from "@/components/admin/ArticleList";
import { SchedulerPage } from "@/components/admin/SchedulerPage";
import SitemapAutoUpdater from "@/components/admin/SitemapAutoUpdater";
import { cn } from "@/lib/utils";

const AdminPage = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    const pathname = useLocation().pathname;

    const getUserRole = async () => {
        try {
            const res = await auth.getRole();
            setRole(res.role);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        getUserRole();
    }, [])

    useEffect(() => {
        setLoading(true);
        if (!isAuth()) {
            navigate("/auth");
        } else {
            if (role === "admin") {
                setLoading(false);
                setIsAdmin(true);
            } else if (role === null) {
                setLoading(true);
            } else {
                setLoading(false);
                setIsAdmin(false);
            }
        }
    }, [role])

    if (loading) {
        return null;
    }

    if (!isAdmin && !loading) {
        return <Page404 />;
    }

    const checkActiveRoute = (path) => {
        console.log(pathname)
        return path === pathname
    }

    const tabStyle = (path) =>
        cn(
            "text-sm font-medium px-4 py-2 rounded-lg",
            checkActiveRoute(path) ? "bg-olive-800 text-white" : " text-foreground text-foreground bg-olive-100"
        )

    return (
        <div className="min-h-screen px-4 sm:px-8 py-8">
            <Header />
            <div className="max-w-6xl mx-auto mt-16">
                <h1 className="mb-8">Админ панель</h1>

                <div className="flex my-8">
                    <Link to="/admin" className={tabStyle("/admin")}>Расписание</Link>
                    <Link to="/admin/users" className={tabStyle("/admin/users")}>Пользователи</Link>
                    <Link to="/admin/articles" className={tabStyle("/admin/articles")}>Статьи</Link>
                    <Link to="/admin/sitemap" className={tabStyle("/admin/sitemap")}>Sitemap</Link>
                </div>

                <Outlet />
            </div >
            <Toaster />
        </div >
    )
}

export default AdminPage